<style lang="scss" scoped>
.barcontainer {
  height: 50px;
  position: relative;
  .target {
    z-index: 4;
    position: absolute;
    height: 25px;
    width: 2px;
    top: 50%;
    transform: translateY(-50%);
    background-color: #000;
  }

  .line {
    z-index: 1;
    position: absolute;
    height: 1px;
    width: 100%;
    transform: translateY(-1px);
    border-bottom: 1px solid $c-dark-grey;
    //background-color: $c-dark-grey;
    top: 50%;
  }

  .historybar {
    z-index: 5;
    position: absolute;
    top: 50%;
    height: 14px;
    transform: translate(-0.25%, -50%);
    border-radius: 7px;
    min-width: 1%;
    //background-color: $c-dark-grey;
    //opacity: 0.3;
    border: 1px solid $c-dark-grey;
  }
  .bar {
    transition: all 0.5s;
    z-index: 3;
    position: absolute;
    top: 50%;
    height: 10px;
    transform: translateY(-50%);
    border-radius: 5px;
    min-width: 1%;

    &.color-nothing {
      background-color: $c-light-blue;
    }
    &.color-low {
      background-color: $c-light-blue;
    }

    &.color-medium {
      background-color: $c-medium-blue;
    }

    &.color-high {
      background-color: $c-dark-blue;
    }
  }

  .novalue {
    background-color: white;
    padding: 5px;
    z-index: 5;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    left: 50%;
  }
}
</style>

<template>
  <div class="barcontainer">
    <div class="novalue" v-if="value < 0">Keine Einschätzung vorhanden</div>
    <div class="bar" :class="`color-${clazz(value)}`" :style="`width:${getOffset(value)}%`" v-if="value >= 0"></div>
    <div class="historybar" :style="`width:${getOffset(history) + 0.5}%`" v-if="history >= 0"></div>
    <div class="line"></div>
    <div class="target" :style="`left:${getOffset(target)}%`" v-if="target && target > 0"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
  props: {
    value: { type: Number, required: true },
    target: { type: Number, required: true },
    history: { type: Number, default: -1 },
  },
  setup(props) {
    const store = useStore();
    const clazz = (id: number) => store.getters.getRating(id);

    const getOffset = (value: number) => 100 * value;

    return {
      getOffset,
      clazz,
    };
  },
});
</script>
